module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/regenerator/index.js
// module id = 21
// module chunks = 0 1 2 4